module.exports = {
      id: "podcast-usage",
      viewBox: "0 0 104.071 88.89",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#podcast",
      toString: function () {
        return this.url;
      }
    }